/**
 * Video Maximizer - Zoom to Fill
 *
 * Declares a single web-accessible-resource — `videomax_inject.css` — matched to
 * `<all_urls>` with no `use_dynamic_url`. That one vendor-named stylesheet is fetchable
 * from any page at a fixed URL that carries the extension ID, so a successful fetch is
 * conclusive: it is served only when the extension is installed.
 *
 * Manifest verified against version 3.0.120.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'cdnlfphfngnfhjcnoikfhaomaaflaiie';

export const videoMaximizer: ExtensionDefinition = {
  id: ID,
  name: 'Video Maximizer - Zoom to Fill',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 10_000,
  notes:
    'A single WAR (videomax_inject.css) on every origin with no dynamic URL. ' +
    'Detection is one conclusive fetch.',
  signals: [
    {
      id: 'war-videomax-inject-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch videomax_inject.css — the vendor-named injected stylesheet exposed to every ' +
        'origin, present only when the extension is installed.',
      weight: 1,
      run: () => probeFetch(ID, 'videomax_inject.css'),
    },
  ],
};
